import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import {Container, Grid, Statistic} from 'semantic-ui-react';

import DynamicTable from "../../components/extras/DynamicTable";
import {FormattedNumber} from "react-intl";
import SaleData from "../../data/SaleData";
import Loading from "../../components/extras/Loading";
import GoToSale from "../../components/sale/GoToSale";

class OutstandingBalance extends Component {
    constructor(props){
        super(props);
        this.state = {
            table_balances: {
                headers: ['Nº', 'Cliente', 'Total Venta', 'Descuento', 'Pagos', 'Saldo Pendiente', 'Acciones'],
                name: 'Venta',
                title: 'Saldos Pendientes',
                has_actions: false,
                navigate: false,
                pagination: true,
                url: 'sales/balances',
                values: ['id', 'billing_number', 'client', 'total_sum', 'discount', 'payments_sum', 'balance', 'state'],
                id: 'table_balances',
                money_fields: ['total_sum', 'payments_sum', 'balance', 'discount'],
                component_fields: [{state:GoToSale}]
            },
            total: 0,
            loading: true
        }
    }

    componentWillMount() {
        SaleData.getTotalBalance().then(total_balance =>{
            this.setState({total:total_balance[0].balance})
        }).catch(() => this.setState({total:0})).finally(() => this.setState({loading:false}));
    }

    render() {
        return (
            this.state.loading ? <div style={{paddingBottom:'3em'}}><Loading/></div>:<div>
                <Container textAlign='center'>
                    <Statistic>
                        <Statistic.Value>
                        $<FormattedNumber value={this.state.total} currency="USD" maximumFractionDigits={0} minimumFractionDigits={0}/>
                        </Statistic.Value>
                        <Statistic.Label>Total Saldos Pendientes</Statistic.Label>
                    </Statistic>
                    <br/>
                </Container>
                <Grid stackable>
                    <Grid.Row columns={1}>
                        <Grid.Column>
                            <DynamicTable {...this.state.table_balances} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default withRouter(OutstandingBalance);



// WEBPACK FOOTER //
// ./src/containers/sale/OutstandingBalance.js